import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DataTables from "./DataTables"
import MetaTag from "components/Common/Meta-tag"

function YoutubeShortVideos() {
  return (
    <>
      <MetaTag title={"All Youtube Short Videos"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All Youtube Short Videos" />
        <Container fluid>
          <div className="container-fluid">
            <DataTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default YoutubeShortVideos
